import React from 'react';
import { ArrowLeft } from 'lucide-react';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-slate-900 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <a 
            href="/" 
            className="inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors mb-4"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </a>
          <h1 className="text-3xl sm:text-4xl font-bold text-white">Impressum</h1>
          <p className="text-white/60 mt-2">Angaben gemäß § 5 TMG, § 55 RStV</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-12 space-y-8">
          
          {/* Angaben gemäß § 5 TMG */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">Angaben gemäß § 5 TMG</h2>
            <div className="text-slate-700 space-y-1">
              <p className="font-semibold text-lg">Sunprojects GmbH</p>
              <p>Bornbachstraße 80</p>
              <p>35789 Weilmünster</p>
              <p>Deutschland</p>
            </div>
          </section>

          {/* Vertreten durch */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">Vertretungsberechtigter Geschäftsführer</h2>
            <p className="text-slate-700">Michael Kaufmann (einzelvertretungsberechtigt)</p>
          </section>

          {/* Kontakt */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">Kontakt</h2>
            <div className="text-slate-700 space-y-1">
              <p>Telefon: +49 2235 9762339</p>
              <p>E-Mail: info@sunprojects-gmbh.de</p>
              <p>Website: www.sunprojects-gmbh.de</p>
            </div>
          </section>

          {/* Registereintrag */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">Handelsregister</h2>
            <div className="text-slate-700 space-y-1">
              <p>Registergericht: Amtsgericht Köln</p>
              <p>Registernummer: HRB 93908</p>
            </div>
          </section>

          {/* Umsatzsteuer-ID */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">Umsatzsteuer-Identifikationsnummer</h2>
            <div className="text-slate-700">
              <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:</p>
              <p className="mt-2 font-medium">DE318560405</p>
            </div>
          </section>

          {/* Handwerkskammer & Aufsichtsbehörde */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">Berufsrechtliche Angaben</h2>
            <div className="text-slate-700 space-y-4">
              <div>
                <p className="font-medium text-slate-900">Berufsbezeichnung:</p>
                <p>Elektrotechniker (verliehen in der Bundesrepublik Deutschland)</p>
              </div>
              <div>
                <p className="font-medium text-slate-900">Zuständige Handwerkskammer:</p>
                <p>Handwerkskammer zu Köln</p>
                <p>Heumarkt 12</p>
                <p>50667 Köln</p>
                <p>
                  <a 
                    href="https://www.hwk-koeln.de" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-sun-orange hover:underline"
                  >
                    www.hwk-koeln.de
                  </a>
                </p>
              </div>
              <div>
                <p className="font-medium text-slate-900">Eintragung in die Handwerksrolle:</p>
                <p>Das Unternehmen ist in der Handwerksrolle der Handwerkskammer zu Köln eingetragen.</p>
              </div>
              <div>
                <p className="font-medium text-slate-900">Berufsrechtliche Regelungen:</p>
                <p>Handwerksordnung (HwO) – einsehbar unter:</p>
                <p>
                  <a 
                    href="https://www.gesetze-im-internet.de/hwo/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-sun-orange hover:underline"
                  >
                    www.gesetze-im-internet.de/hwo/
                  </a>
                </p>
              </div>
            </div>
          </section>

          {/* Verantwortlich für den Inhalt */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <div className="text-slate-700 space-y-1">
              <p className="font-medium">Michael Kaufmann</p>
              <p>Sunprojects GmbH</p>
              <p>Bornbachstraße 80</p>
              <p>35789 Weilmünster</p>
            </div>
          </section>

          {/* EU-Streitschlichtung */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">Online-Streitbeilegung (OS)</h2>
            <div className="text-slate-700 space-y-4">
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit.
                Diese Plattform finden Sie unter:
              </p>
              <p>
                <a 
                  href="https://ec.europa.eu/consumers/odr/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sun-orange hover:underline font-medium"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p>
                Unsere E-Mail-Adresse lautet: info@sunprojects-gmbh.de
              </p>
            </div>
          </section>

          {/* Verbraucherstreitbeilegung */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">Verbraucherstreitbeilegung nach VSBG</h2>
            <div className="text-slate-700 space-y-4">
              <p>
                Wir sind gemäß § 36 Verbraucherstreitbeilegungsgesetz (VSBG) weder bereit noch verpflichtet, 
                an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
              <p>
                Im Falle von Beschwerden wenden Sie sich bitte direkt an uns unter den oben genannten 
                Kontaktdaten. Wir bemühen uns, Unstimmigkeiten einvernehmlich zu klären.
              </p>
            </div>
          </section>

          <hr className="border-slate-200" />

          {/* Haftungsausschluss Überschrift */}
          <div>
            <h2 className="text-2xl font-bold text-slate-900">Haftungsausschluss (Disclaimer)</h2>
          </div>

          {/* Haftung für Inhalte */}
          <section>
            <h3 className="text-lg font-bold text-slate-900 mb-4">1. Haftung für Inhalte</h3>
            <div className="text-slate-700 space-y-4">
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten 
                nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
                Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
                Tätigkeit hinweisen.
              </p>
              <p>
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den 
                allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch 
                erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei 
                Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend 
                entfernen.
              </p>
            </div>
          </section>

          {/* Haftung für Links */}
          <section>
            <h3 className="text-lg font-bold text-slate-900 mb-4">2. Haftung für Links</h3>
            <div className="text-slate-700 space-y-4">
              <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
                Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
                Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der 
                Seiten verantwortlich.
              </p>
              <p>
                Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße 
                überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. 
                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete 
                Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
              </p>
              <p>
                Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>
            </div>
          </section>

          {/* Urheberrecht */}
          <section>
            <h3 className="text-lg font-bold text-slate-900 mb-4">3. Urheberrecht</h3>
            <div className="text-slate-700 space-y-4">
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
                dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
                der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
                Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
              <p>
                Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch 
                gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden 
                die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche 
                gekennzeichnet.
              </p>
              <p>
                Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um 
                einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir 
                derartige Inhalte umgehend entfernen.
              </p>
            </div>
          </section>

          {/* Bild- und Medienrechte */}
          <section>
            <h3 className="text-lg font-bold text-slate-900 mb-4">4. Bildnachweise</h3>
            <div className="text-slate-700 space-y-4">
              <p>
                Alle auf dieser Website verwendeten Bilder, Grafiken und Videos sind urheberrechtlich 
                geschützt. Die Bildrechte liegen, sofern nicht anders angegeben, bei der Sunprojects GmbH 
                oder wurden ordnungsgemäß lizenziert.
              </p>
              <p>
                Verwendete Stockbilder: Unsplash, Pexels (lizenzfrei)<br />
                Firmenfotos und Projektbilder: © Sunprojects GmbH
              </p>
            </div>
          </section>

          {/* Keine Rechtsberatung */}
          <section>
            <h3 className="text-lg font-bold text-slate-900 mb-4">5. Keine Rechts- oder Steuerberatung</h3>
            <div className="text-slate-700 space-y-4">
              <p>
                Die auf dieser Website bereitgestellten Informationen zu Förderprogrammen, steuerlichen 
                Aspekten und rechtlichen Rahmenbedingungen dienen ausschließlich der allgemeinen 
                Information. Sie stellen keine Rechts- oder Steuerberatung dar und ersetzen nicht die 
                individuelle Beratung durch einen Rechtsanwalt oder Steuerberater.
              </p>
              <p>
                Für die Richtigkeit, Vollständigkeit und Aktualität dieser Informationen übernehmen wir 
                keine Haftung. Die Nutzung der Informationen erfolgt auf eigene Gefahr des Nutzers.
              </p>
            </div>
          </section>

          {/* Leistungsangaben */}
          <section>
            <h3 className="text-lg font-bold text-slate-900 mb-4">6. Hinweise zu Leistungsangaben und Berechnungen</h3>
            <div className="text-slate-700 space-y-4">
              <p>
                Angaben zu Energieerträgen, Einsparungen, Autarkiegraden und Wirtschaftlichkeitsberechnungen 
                auf dieser Website sind Durchschnittswerte oder Beispielrechnungen. Die tatsächlichen Werte 
                können aufgrund individueller Faktoren (Standort, Dachausrichtung, Verbrauchsverhalten, 
                Wetterbedingungen, etc.) abweichen.
              </p>
              <p>
                Der auf dieser Website bereitgestellte Autarkie-Rechner dient ausschließlich zu 
                Informationszwecken und ersetzt keine individuelle Beratung oder ein verbindliches Angebot.
              </p>
            </div>
          </section>

          {/* Gewährleistung */}
          <section>
            <h3 className="text-lg font-bold text-slate-900 mb-4">7. Gewährleistung und Garantie</h3>
            <div className="text-slate-700 space-y-4">
              <p>
                Für unsere Leistungen gelten die gesetzlichen Gewährleistungsfristen. Darüber hinausgehende 
                Garantien werden von uns nur gegeben, wenn diese ausdrücklich und schriftlich vereinbart wurden.
              </p>
              <p>
                Herstellergarantien auf Komponenten (Module, Wechselrichter, Speicher) sind von der 
                gesetzlichen Gewährleistung unabhängig und richten sich nach den jeweiligen 
                Herstellerbedingungen.
              </p>
            </div>
          </section>

          {/* Datenschutz Hinweis */}
          <section>
            <h3 className="text-lg font-bold text-slate-900 mb-4">8. Datenschutz</h3>
            <div className="text-slate-700">
              <p>
                Ausführliche Informationen zum Umgang mit Ihren personenbezogenen Daten finden Sie in 
                unserer{' '}
                <a 
                  href="/datenschutz" 
                  className="text-sun-orange hover:underline font-medium"
                >
                  Datenschutzerklärung
                </a>.
              </p>
            </div>
          </section>

          {/* Salvatorische Klausel */}
          <section>
            <h3 className="text-lg font-bold text-slate-900 mb-4">9. Salvatorische Klausel</h3>
            <div className="text-slate-700">
              <p>
                Sofern einzelne Teile oder Formulierungen dieses Textes der geltenden Rechtslage nicht, 
                nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile des 
                Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.
              </p>
            </div>
          </section>

        </div>

        {/* Footer Note */}
        <div className="text-center mt-8 space-y-2">
          <p className="text-slate-500 text-sm">
            Stand: Dezember 2025
          </p>
          <p className="text-slate-400 text-xs">
            Dieses Impressum gilt auch für unsere Social-Media-Auftritte.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ImpressumPage;
